import {
    getSearchData,
    hasFilledDates,
    isHPDestinationEmptySearchErrorExperimentAvailable,
    removeSearchCookieDates,
    triggerDestinationEmptySearchErrorEdapEvent,
    triggerSearchQuerySubmittedEdapEvent,
    triggerSearchSubmitEdapEvent
} from './';

function submitForm(tracking, system, abacus, edap, search, form, destination, dates, guests) {
    const {
        actions: {
            setIsSubmitting: setIsFormSubmitting,
            setHasSubmitted: setHasFormSubmitted,
            setHasSubmittedSuccessfully: setHasFormSubmittedSuccessfully,
            setWasLastSubmittedSuccessfully: setWasFormLastSubmittedSuccessfully
        },
        events: {
            onSubmit
        }
    } = form;

    const {
        actions: {
            setIsTypeaheadInputFocus: setIsDestinationTypeaheadInputFocus
        },
        selectors: {
            isValid: isDestinationValid
        }
    } = destination;

    const {
        latestValues: {
            startDate,
            endDate
        }
    } = dates;

    setHasFormSubmitted(true);

    if (!isDestinationValid()) {
        setWasFormLastSubmittedSuccessfully(false);
        setIsDestinationTypeaheadInputFocus(true);

        if (isHPDestinationEmptySearchErrorExperimentAvailable(abacus, system, destination)) {
            triggerDestinationEmptySearchErrorEdapEvent(tracking);
        }

        return;
    }

    setIsFormSubmitting(true);

    if (!hasFilledDates(startDate, endDate)) {
        removeSearchCookieDates();
    }

    triggerSearchSubmitEdapEvent(tracking, edap, search, destination, dates, guests);
    triggerSearchQuerySubmittedEdapEvent(tracking, edap);

    const searchData = getSearchData(search, destination, dates, guests);

    setTimeout(function stopSubmitting() {
        setIsFormSubmitting(false);
    }, 3500);

    setHasFormSubmittedSuccessfully(true);
    setWasFormLastSubmittedSuccessfully(true);

    onSubmit(searchData);
}

export {
    submitForm
};
